<template>
  <div class="page_main">
    <my_menu2 page_name="员工查询" back_type="back" back_icon="md-arrow-back"></my_menu2>
    <div style="height: 50px"></div>
    <!-- <div class="head_box">
      <div class="head_left">
        <img class="logo_img" src="@/assets/image/auth/logo_white.png" alt="" />
        <span class="head_title">项目·查询员工</span>
      </div>
      <div class="head_right"></div>
    </div> -->

    <Alert type="warning" style="padding-left: 30px">提示：以下信息为公司内部数据，并涉及员工个人信息，查询记录会后台保存，请严格保密！</Alert>

    <div class="detail_main">
      <Spin v-if="table_loading" fix />
      <div class="detail_inner">
        <Alert v-if="resume_basic_info.is_black_list == 1" type="error" style="padding-left: 30px">
          重要提示：该员工在黑名单中,化黑原因及更多信息请<span class="click_black_list_span" @click="click_black_list">点击这里查看》</span></Alert>
        <div class="detail_title">
          <Icon type="md-bookmark" /> 简历基本信息：
        </div>
        <div class="detail_value2">
          <div class="value_div">
            <div class="field_title">简历ID：</div>
            <div class="field_value">
              {{ resume_basic_info.resume_id }}
            </div>
          </div>

          <div class="value_div">
            <div class="field_title">姓名：</div>
            <div class="field_value">
              {{ resume_basic_info.name }}
            </div>
          </div>
          <div class="value_div">
            <div class="field_title">性别：</div>
            <div class="field_value">
              {{ resume_basic_info.gender }}
            </div>
          </div>
          <div class="value_div">
            <div class="field_title">年龄：</div>
            <div class="field_value">{{ resume_basic_info.age }}岁</div>
          </div>
          <div class="value_div">
            <div class="field_title">身份证号：</div>
            <div class="field_value">
              {{ resume_basic_info.idcard }}
              <Tag checkable color="success" v-if="resume_basic_info.is_certification == 1">已认证</Tag>
              <Tag checkable color="error" v-if="resume_basic_info.is_certification == 0">未认证</Tag>
            </div>
          </div>
          <div class="value_div">
            <div class="field_title">手机号：</div>
            <div class="field_value">
              {{ resume_basic_info.phone }}
            </div>
          </div>
          <div class="value_div">
            <div class="field_title">身份证籍贯：</div>
            <div class="field_value">
              {{ resume_basic_info.address }}
            </div>
          </div>
          <div class="value_div">
            <div class="field_title">户口所在地：</div>
            <div class="field_value">
              {{ resume_basic_info.hukou_address }}
            </div>
          </div>
        </div>
      </div>
      <div class="detail_inner">
        <div class="detail_title">
          <Icon type="md-bookmark" /> 身份证信息：
        </div>

        <div class="detail_value2">
          <div class="detail_value2-1">
            下载提示：图片预览下载如果无反应，可在图片上鼠标右键【图片另存为】
          </div>
          <div class="value_div2">
            <div class="field_title">身份证正反面：</div>
            <div>
              <img v-if="idcard_info.idcard_img_a_url" title="点击查看大图" class="idcard_img"
                @click="view_pic(idcard_info.idcard_img_a_url)" :src="idcard_info.idcard_img_a_url" alt="" />

              <img v-if="idcard_info.idcard_img_b_url" title="点击查看大图" class="idcard_img"
                @click="view_pic(idcard_info.idcard_img_b_url)" :src="idcard_info.idcard_img_b_url" alt="" />
            </div>
          </div>
        </div>
      </div>

      <div class="detail_inner">
        <div class="detail_title">
          <Icon type="md-bookmark" /> 工资卡：
        </div>
        <div class="card_div_main">
          <div v-for="(item, i) in bank_card_list" :key="i" class="card_div1">
            <div class="card_div">
              <div class="bankcard_type">
                类型：{{ item.is_self == 1 ? '本人工资卡' : '非本人工资卡' }}
              </div>
                <div class="bankcard_type">
                类型：{{ item.is_default == 1 ? '默认卡' : '非默认卡' }}
              </div>
              <div class="bankcard_type">
                银行名称：{{ item.bank_name }}
              </div>
              <div class="bankcard_type">
                开户地区：{{ item.bank_card_area }}
              </div>
              <div class="bankcard_type">
                卡片类型：{{ item.bank_card_name }}
              </div>
              <div class="bankcard_type">
                银行卡户主：{{ item.bank_card_name }}
              </div>
              <div class="bankcard_type">
                发薪委托书：<span class="view_weituoshu" @click="view_weituoshu(item)" ><Icon  type="ios-eye-outline" /> {{ item.weituo_url!=''?'有':'无' }}</span>
              </div>
              <div class="backcard_number">
                {{ item.bank_card_number }}
              </div>
              <img class="card_icon" :src="item.bank_img" alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="detail_inner">
        <div class="detail_title">
          <Icon type="md-bookmark" /> 面试、入职信息：
        </div>

        <div class="project_div">
          <Tabs size="small" v-model="interview_project_id">
            <TabPane :label="item.label" :name="item.value" v-for="(item, i) in interview_project_list" :key="i">
            </TabPane>
          </Tabs>
          <div class="project_auth_project_div">
            <span class="project_auth_title">项目部门：{{ project_team_dict[interview_project_id] }}</span>
          </div>
          <div class="project_auth_project_div">
            <span class="project_auth_title">项目客服：</span>

            <div class="project_auth_div">
              <span v-for="(item, i) in project_auth_dict[interview_project_id]" :key="i" class="auth_name">
                {{ item.name }}
              </span>
            </div>
          </div>
          <div class="projecet_interview_main">
            <div v-if="interview_project_id != ''">
              <div v-for="(k, v) in interview_dict[interview_project_id]" :key="v" class="projecet_interview">
                <div class="project_interview_num">
                  <div class="project_interview_num_cir">
                    {{ v + 1 }}
                  </div>
                </div>
                <div class="project_table">
                  <Table size="small" :columns="interview_columns" :data="k"></Table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="detail_inner">
        <div class="detail_title">
          <Icon type="md-bookmark" /> 合同信息：
        </div>

        <div class="detail_value2">
          <Button @click="click_hetong" type="primary">打开合同详情页
            <Icon type="ios-arrow-dropright-circle" />
          </Button>
        </div>
      </div>

      <div class="detail_inner">
        <div class="detail_title">
          <Icon type="md-bookmark" /> 保险信息：
        </div>

        <div class="detail_value2">
          <Button @click="click_baoxian" type="primary">打开保险详情页
            <Icon type="ios-arrow-dropright-circle" />
          </Button>
        </div>
      </div>

      <div class="detail_inner">
        <div class="detail_title">
          <Icon type="md-bookmark" /> 工资记录：
        </div>

        <div class="" v-if="transfer_auth">
          <Table size="small" :columns="transfer_columns" :data="transfer_data" height="600">
            <template #xtr_receipt="{ row }">
              <Button type="primary" size="small" style="font-size: 12px" :disabled="row.xtr_receipt == ''"
                icon="ios-search" @click="view_pdf(row.xtr_receipt)">薪太软凭证</Button>
            </template>
            <template #bank_receipt="{ row }">
              <Button type="primary" size="small" style="font-size: 12px" :disabled="row.bank_receipt == ''"
                icon="ios-search" @click="view_pdf(row.bank_receipt)">银行凭证</Button>
            </template>
          </Table>
        </div>
        <div v-else class="no_transfer_auth_div">
          正在加载中，请稍等片刻
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";
import my_menu2 from "@/component/menu/menu2.vue";

import watermark from "@/utils/shuiyin.js";

export default {
  components: {
    my_menu2,
  },

  data() {
    return {
      resume_basic_info: {},
      idcard_info: {},
      interview_dict: {},
      project_auth_dict: {},
      project_team_dict: {},
      interview_project_list: [],
      interview_project_id: "",
      interview_columns: [],
      table_loading: false,
      transfer_auth: false,
      transfer_columns: [],
      transfer_data: [],
      syid: "",
      bank_card_list: []
    };
  },
  mounted() {
    this.search_request();
    this.search_staff_transfer();
    this.create_shuiyin();
    this.staff_bankcard();
  },
  methods: {
    view_weituoshu(item){
      if(item.weituo_url==''){
        this.$Message.error('暂无委托书')
      }else{
        open_new_page(item.weituo_url);
      }
      
    },

    click_hetong() {
      var idcard = this.resume_basic_info.idcard;
      var url =
        "https://contract.daxiangsys.com/contract_manage/search/detail?idcard=" + idcard;
      open_new_page(url);
    },

    click_baoxian() {
      var idcard = this.resume_basic_info.idcard;
      var url = "https://insurance.daxiangsys.com/info/search/detail/?idcard=" + idcard;
      open_new_page(url);
    },

    create_shuiyin() {
      var user_info = this.$cookies.get("dx_user_info");
      if (user_info) {
        var name = user_info.name;
        var time = new Date().toLocaleString();
        console.log(time);
        this.syid = watermark.set("保密-" + name + "-" + time, "0px");
      }
    },
    view_pic(url) {
      this.$ImagePreview.show({
        previewList: [url],
      });
    },

    search_request() {
      var query = this.$route.query;
      var idcard = query.idcard;
      if (!idcard) {
        this.$Message.error("参数异常");
      }
      console.log(idcard);
      this.loading = true;
      var that = this;
      var obj = {
        idcard: idcard
        
      };
      this.table_loading = true;
      http("post", process.env.VUE_APP_HOST + "/query_staff/search", obj, true)
        .then((res) => {
          if (res.code == 0) {
            this.idcard_info = res.data.idcard_info;
            this.resume_basic_info = res.data.resume_basic_info;
            this.interview_dict = res.data.interview_dict;
            this.interview_columns = res.data.interview_columns;
            this.interview_project_list = res.data.interview_project_list;
            this.project_auth_dict = res.data.project_auth_dict;
            this.project_team_dict = res.data.project_team_dict;
            if (this.interview_project_list.length > 0) {
              this.interview_project_id = this.interview_project_list[0]["value"];
            }
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.table_loading = false;
        })
        .catch((res) => {
          that.table_loading = false;

          console.log(res, "请求出错");
        });
    },

    //搜索员工转帐记录
    search_staff_transfer() {
      var query = this.$route.query;
      var idcard = query.idcard;
      if (!idcard) {
        this.$Message.error("参数异常");
      }
      this.loading = true;
      var that = this;
      var obj = {
        idcard: idcard,
      };
      this.table_loading = true;
      http("post", process.env.VUE_APP_HOST + "/query_staff/staff_transfer", obj, true)
        .then((res) => {
          if (res.code == 0) {
            this.transfer_auth = true;

            this.transfer_columns = res.data.columns;
            this.transfer_data = res.data.table_data;
          } else {
            if (res.code == 96) {
              this.transfer_auth = false;
            } else {
              that.$Message.error({
                content: res.msg,
                duration: 3,
              });
            }
          }
          that.table_loading = false;
        })
        .catch((res) => {
          that.table_loading = false;

          console.log(res, "请求出错");
        });
    },

    staff_bankcard() {
      var query = this.$route.query;
      var idcard = query.idcard;

      var that = this;
      var obj = {
        idcard: idcard,
      };
      http("post", process.env.VUE_APP_HOST + "/query_staff/staff_bankcard", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.bank_card_list = res.data.bank_card_list
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {

          console.log(res, "请求出错");
        });

    },

    view_pdf(url) {
      open_new_page(url);
    },
    click_black_list() {
      var idcard = this.resume_basic_info.idcard
      var url = 'https://recruitment.daxiangsys.com/black_list?search_type=idcard&search_value=' + idcard;
      open_new_page(url)
    }
  },



  beforeUnmount() {
    console.log("页面卸载");
    const canvas = document.getElementById(this.syid);
    console.log(canvas);
    canvas.remove();
    // const ctx = canvas.getContext('2d');

    // ctx.clearRect(0, 0, canvas.width, canvas.height);
  },
};
</script>

<style scoped>
.view_weituoshu{
  cursor: pointer;
  color:#0466dd
}

.card_div1 {
  margin: 0 10px 10px 0;
}

.card_div:hover {
  box-shadow: 0 0 2px #51c4fd;
  cursor: pointer;
}

.card_div_main {
  display: flex;
  flex-wrap: wrap;
}

.bankcard_type {
  font-size: 13px;
  color: #666;
}

.backcard_number {
  font-weight: 600;
  margin: 5px 0 0 0;
  font-size: 14px;
  letter-spacing: 1.5px;
}

.card_icon {
  width: 40px;
  position: absolute;
  opacity: .5;
  top: 10px;
  right: 10px;
}

.card_div {
  position: relative;
  width: 250px;
  padding: 10px;
  background-color: #fff;
  border: 2px solid #f7f1f3;
  border-radius: 10px;
}

.project_auth_project_div {
  display: flex;
  flex-wrap: wrap;
  padding-left: 10px;
  margin-bottom: 10px;
}

.project_auth_title {
  font-size: 13px;
  color: #666;
}

.project_auth_div {
  display: flex;
  flex-wrap: wrap;
}

.click_black_list_span {
  cursor: pointer;
  color: #0466dd;
}

.auth_name {
  display: flex;
  align-items: center;
  padding: 3px 5px;
  margin-right: 10px;
  font-size: 12px;
  color: #fff;
  border-radius: 3px;
  background: rgb(71, 167, 71);
}

.detail_value2-1 {
  font-size: 12px;
  color: #ccc;
  margin-bottom: 10px;
}

.project_interview_num_cir {
  background-color: #fff;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  text-align: center;
  line-height: 22px;
  color: #195faf;
  margin: 4px;
}

.field_value {
  color: #888;
}

.project_div {}

.no_transfer_auth_div {
  text-align: center;
  padding: 20px;
  color: #ccc;
  border: 1px solid #ececec;
}

.project_table {
  border: 1px solid #ececec;
}

.project_interview_num {
  font-size: 13px;
  padding: 3px 0;
  line-height: 30px;
  background-color: #0466dd;
  color: #fff;
  display: flex;
  justify-content: center;
  /* border-radius: 50px; */
}

.projecet_interview_main {
  max-height: 500px;
  overflow: auto;
}

.projecet_interview {
  /* border: 1px solid #ececec; */
  margin-bottom: 10px;
}

.interview_div {
  padding: 10px;
  box-shadow: 0 0 3px #ccc;
  margin-bottom: 10px;
  border-radius: 5px;
}

.detail_value2 {
  padding: 0 0 0 20px;
}

.detail_title {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #0466dd;
}

.detail_inner {
  padding: 20px 20px 10px 20px;
  background-color: #fff;
  margin-bottom: 10px;
  border-radius: 5px;
}

.detail_main {
  height: calc(100vh - 100px);
  overflow: auto;
}

.page_main {
  height: 100vh;
  overflow: auto;
  background-color: #ececec;
}

.idcard_img {
  cursor: pointer;
  width: 100px;
  height: 70px;
  margin-right: 10px;
  border-radius: 5px;
}

.value_div {
  display: flex;
  margin-bottom: 5px;
}

.value_div2 {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.field_title {
  width: 120px;
  flex-shrink: 0;
}

/* 顶部 */

.logo_img {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}

.head_title {
  cursor: pointer;
  letter-spacing: 3px;
  font-size: 16px;
  font-weight: 400;
  color: rgb(255, 255, 255);
}

.head_left {
  display: flex;
  align-items: center;
}

.head_box {
  background: #0466dd;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0 0 40px;
}

/*  */
</style>
